import { api } from "@/lib/api";

// Pure, authoritative landing decision shared by local login AND SSO completion.
//   Staff (any non-viewer platform role) -> /my-work (dual-role staff switch to Forum in-app).
//   Board-only (viewer role + board membership) -> /forum.
export function landingPathFor(role, isBoardUser) {
  const r = role || "viewer";
  if (r === "viewer" && isBoardUser) return "/forum";
  return "/my-work";
}

// Resolves the correct landing path from the authenticated session. Used identically
// after local login and after the SSO callback so routing can never drift between them.
export async function resolveLandingPath() {
  try {
    const me = await api.get("/auth/me");
    const role = me.data?.role || "viewer";
    if (role === "viewer") {
      const mem = await api.get("/forum/my-memberships");
      return landingPathFor(role, mem.data?.is_board_user);
    }
    return landingPathFor(role, false);
  } catch {
    return "/my-work";
  }
}
